<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/ISUcQ6/tc-custom/9781250785794.jpg?1737766937184" alt="This image is the cover for the book The Preppy Murder Trial"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Preppy Murder Trial
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Bryna Taubman's <i>The Preppy Murder Trial</i> recreates firsthand the case of Robert Chambers--more sensational than any novel.</b><br/><br/> Taubman follows the 16-month headline-making investigation to the jarring plea bargain that ended a trial marred by accusations of foul play, sexism, and a crumbling jury. Intricate and fascinating, this true crime account explores every facet of Chambers's case--from the real human drama to the questions left unanswered about his strangling of an 18-year-old girl in Central Park.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Bryna Taubman
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      St. Martin’s Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?35ec2be6